module.exports = __webpack_public_path__ + "public/img/logo_unmer.1be9aaed.png";